import { gql } from '@zenbusiness/application-commons-graphql';

export const DOMAIN_VIEW_READ = gql`
  query DomainView($domainUuid: UUID!, $businessEntityUuid: UUID!) {
    domain(domainUuid: $domainUuid) {
      domainUuid
      domainName
      active
      configured
      domainPrivacy
      transferred
      verified
      expired
      isExternal
      useZenbusinessNameservers
      srsExpireDatetime
      websiteUuid
      deleted
      websiteConnectionStatus
      domainDns {
        domainDnsUuid
        type
        editable
        deleted
        updatedDatetime
        dnsConfiguration {
          ipAddress
          subdomain
          hostname
          text
          priority
          port
          weight
          destinationUrl
        }
      }
      domainNameservers {
        domainNameserverUuid
        name
        deleted
        updatedDatetime
        createdDatetime
      }
      domainContacts {
        domainContactUuid
        contactType
        firstName
        lastName
        address1
        address2
        city
        state
        zipCode
        # country
        phone
        email
        editable
        updatedDatetime
      }
    }
    websites(businessEntityUuid: $businessEntityUuid) {
      websites {
        websiteUuid
        websiteUrl
        publishStatus
        dudaActive
      }
    }
  }
`;

export const CONNECT_DOMAIN_TO_DUDA = gql`
  mutation ConnectToDudaWebsite($input: ConnectToWebsiteInput!) {
    connectToDudaWebsite(input: $input) {
      domainUuid
      domainName
      active
      configured
      domainPrivacy
      transferred
      verified
      expired
      isExternal
      useZenbusinessNameservers
      srsExpireDatetime
      websiteUuid
      websiteConnectionStatus
      domainDns {
        domainDnsUuid
        type
        editable
        deleted
        updatedDatetime
        dnsConfiguration {
          ipAddress
          subdomain
          hostname
          text
          priority
          port
          weight
          destinationUrl
        }
      }
      domainNameservers {
        domainNameserverUuid
        name
        deleted
        updatedDatetime
        createdDatetime
      }
      domainContacts {
        domainContactUuid
        contactType
        firstName
        lastName
        orgName
        address1
        address2
        city
        state
        zipCode
        phone
        editable
        updatedDatetime
      }
    }
  }
`;

export const REMOVE_DOMAIN = gql`
  mutation DeleteExternalDomain($input: DeleteExternalDomainInput!) {
    deleteExternalDomain(input: $input) {
      domainUuid
      deleted
    }
  }
`;
